import Check28 from '@sats-group/icons/28/check';
import Mail24 from '@sats-group/icons/24/mail';
import Link from '@sats-group/fresh-fitness-ui-lib/react/link';
import LinkButton from '@sats-group/fresh-fitness-ui-lib/react/link-button';
import Text from '@sats-group/fresh-fitness-ui-lib/react/text';
import React from 'react';

import ContentContainer from 'root/client/components/content-container/content-container';
import SalesLayout from 'root/client/components/sales-layout/sales-layout';

import type { CheckoutConfirmation as Props } from './checkout-confirmation.types';

const CheckoutConfirmation: React.FC<Props> = ({
  downloadAppButton,
  home,
  layout,
  purchase,
  receipt,
  title,
  welcome,
}) => (
  <SalesLayout {...layout} theme={SalesLayout.themes.confirmation}>
    <main className="checkout-confirmation">
      <ContentContainer width={ContentContainer.widths.Narrow}>
        <section className="checkout-confirmation__card">
          <div aria-hidden className="checkout-confirmation__success">
            <Check28 />
          </div>
          <div className="checkout-confirmation__welcome">
            <Text
              className="checkout-confirmation__title"
              elementName="h1"
              size={Text.sizes.header1}
              theme={Text.themes.emphasis}
            >
              {title}
            </Text>
            <Text size={Text.sizes.large}>{welcome}</Text>
          </div>
          {purchase ? (
            <>
              <div className="checkout-confirmation__divider" />
              <div
                className="checkout-confirmation__membership"
                data-testid="confirmation-summary"
              >
                <div className="checkout-confirmation__membership-details">
                  <Text
                    className="checkout-confirmation__red-text"
                    elementName="h2"
                    size={Text.sizes.header1}
                    variant={Text.variants.contrast}
                  >
                    {purchase.subscriptionName}
                  </Text>
                  <Text>
                    {purchase.bindingType} · {purchase.club}
                  </Text>
                </div>
                <div className="checkout-confirmation__price">
                  <Text
                    size={Text.sizes.header2}
                    theme={Text.themes.emphasis}
                    className="checkout-confirmation__red-text"
                  >
                    {purchase.paidToday}
                  </Text>
                  <Text>{purchase.subscriptionPriceAfterCampaign}</Text>
                </div>
              </div>
              <div className="checkout-confirmation__divider" />
              <div className="checkout-confirmation__receipt">
                <span
                  aria-hidden
                  className="checkout-confirmation__receipt-icon"
                >
                  <Mail24 />
                </span>
                <Text>{receipt}</Text>
              </div>
            </>
          ) : null}
          {downloadAppButton ? <LinkButton {...downloadAppButton} /> : null}
          <Link className="checkout-confirmation__home" href={home.href}>
            {home.text}
          </Link>
        </section>
      </ContentContainer>
    </main>
  </SalesLayout>
);

export default CheckoutConfirmation;
